import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTypedSelector } from '../reducers';

export const PrivateRoute = ({ children, auth }: { children: JSX.Element, auth?: string }) => {
  const { isLogin, status, loginUser } = useTypedSelector(state => state.auth);

  if (status === 'done' && !isLogin) {
    alert('로그인 후 이용할 수 있습니다.');
    return <Navigate to="/login" />
  }

  if (!!auth && status === 'done' && isLogin && loginUser?.usrAuth !== auth) {
    alert("권한이 없습니다.");
    return <Navigate to="/" />
  }

  return children;
}
